import React from 'react';
import Link from '../components/Link';
import Line from '../components/Line';
import {
    williamhill as williamhillUrls,
} from '../urlConstants';
import '../styles.scss';

const WilliamHill = () => (
    <div className="bs-gamblingCompliance bs-gamblingCompliance--short">
        <div className="bs-gamblingCompliance__message">
            <Line className="bs-gamblingCompliance__line--spacer">
                Bets are accepted in accordance with the operator&#39;s&nbsp;
                <Link
                    href={williamhillUrls.rules}
                    text="rules"
                />.&nbsp;
            </Line>
            <Line>
                William Hill is licensed and regulated by the&nbsp;
            </Line>
            <Line>
                <Link
                    href={williamhillUrls.license}
                    text="UK Gambling Commission no."
                />&nbsp;
                <Link
                    href={williamhillUrls.license}
                    text="000-039225 R-319373-001"
                />.
            </Line>
        </div>
    </div>
);

export default WilliamHill;



// WEBPACK FOOTER //
// /src/js/common/gamblingCompliance/WilliamHill/shortGamblingCompliance.jsx